import { createTheme, createVariant, globalTheme } from '@clds/component-theme';
export const modalNextTheme = createTheme({
    overlay: {
        zIndex: 9000,
        background: globalTheme.palette.overlayDark2,
    },
    fadeDuration: 300,
    wrapperPaddingVariant: {
        md: { wrapper: { padding: globalTheme.spacing.md } },
        none: { wrapper: { padding: '0' } },
    },
});
export const wrapperPaddingVariant = createVariant((props) => 
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
modalNextTheme.wrapperPaddingVariant[props.wrapperPadding || 'md']);
//# sourceMappingURL=theme.js.map